export const formatCurrency = (amount: number, currency = 'USD') =>
  amount.toLocaleString('en-US', {
    style: 'currency',
    currencyDisplay: 'symbol',
    currency,
  });
